/**
 * 外部リンクの管理（フラットオブジェクト）
 * すべての外部リンクをEXTERNAL_LINKSで一元管理します
 */

export const EXTERNAL_LINKS = {
  // 利用規約
  TERMS_OF_SERVICE: 'https://marketing.toridori.me/terms/index.html',
  // クレジットカード決済規定
  CREDIT_CARD_PAYMENT_TERMS:
    'https://toridori.notion.site/toridori/toridori-marketing-13cf1719e3b54ad18510cb5f69dfae18',
  // スタートガイド
  START_GUIDE: 'https://tayori.com/q/toridorimarketing-faq/detail/886270/',

  // タイアップ投稿詳細
  TIEUP_POSTING_DETAILS: 'https://tayori.com/q/toridorimarketing-faq/detail/886130/',
  // 禁止事項
  PROHIBITED_ITEMS: 'https://tayori.com/q/toridorimarketing-faq/detail/881951/',
  // キャンペーン画像例
  CAMPAIGN_IMAGE_EXAMPLES: 'https://tayori.com/q/toridorimarketing-faq/detail/885464/',
  // 同伴者について
  COMPANION_INFO: 'https://tayori.com/q/toridorimarketing-faq/detail/881928/',
  // 定期公開設定について
  REGULAR_PUBLISHING_SETTINGS: 'https://tayori.com/q/toridorimarketing-faq/detail/885191/',
  // 日程調整の仕方
  SCHEDULE_ADJUSTMENT: 'https://tayori.com/q/toridorimarketing-faq/detail/881933/',
  // インフルエンサーの投稿を利用したい（二次利用）場合
  INFLUENCER_POST_REUSE: 'https://tayori.com/q/toridorimarketing-faq/detail/885032/',
  // よくある質問
  FAQ: 'https://tayori.com/q/toridorimarketing-faq/',
  // インフルエンサー視点の注意事項を確認する
  INFLUENCER_ATTENTION_ITEMS: 'https://tayori.com/q/toridoribase-faq/detail/886266/',
  // 申請可能な条件はこちら
  APPLICABLE_CONDITIONS: 'https://tayori.com/q/toridorimarketing-faq/detail/885152/',
  // Instagram連携とは？
  INSTAGRAM_CONNECTION_INFO: 'https://tayori.com/q/toridorimarketing-faq/detail/884262/',
  SERVICE_REFUSE_POSTING: 'https://tayori.com/q/toridorimarketing-faq/detail/881972/',
  NO_CHARGE_FAQ: 'https://tayori.com/q/toridorimarketing-faq/detail/880125/',
  EXPENSE_FAQ: 'https://tayori.com/q/toridorimarketing-faq/detail/875845/',
  EXPENSE_AFTER_PUBLISH_FAQ: 'https://tayori.com/q/toridorimarketing-faq/detail/878174/',

  // 会社概要
  COMPANY_INFO: 'https://toridori.co.jp',
  // プライバシーポリシー
  PRIVACY_POLICY: 'https://marketing.toridori.me/privacy/index.html',
  // トリドリマーケティングTOP
  TOP_MARKETING: 'https://top-marketing.toridori.me',
  // 他社事例紹介
  CASE_STUDIES: 'https://top-marketing.toridori.me/case',
  // likesのお申し込みはこちら
  LIKES_APPLICATION: 'https://sites.google.com/toridori.co.jp/likespage/%E3%83%9B%E3%83%BC%E3%83%A0',
  // LINE公式アカウント
  LINE_OFFICIAL: 'https://line.me/R/ti/p/%40jby6639u',
  LINE_REGISTRATION: 'https://lin.ee/3yEDz2i',
  // Instagram公式アカウント
  INSTAGRAM_OFFICIAL: 'https://www.instagram.com/toridoribase/',
} as const

export type ExternalLinkKey = keyof typeof EXTERNAL_LINKS
